import { useLocation } from "react-router";

export const getParamValue = ( queryElement ) => {
    
    const search = useLocation().search;
    const value = new URLSearchParams(search).get(queryElement);
    
    return value;
}